import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { ProductAction } from 'src/actions/product.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getProductStatus } from 'src/utils/utils';
import {
  Button,
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';

import { useParams } from "react-router-dom";

import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import ProductPrice1 from '../product-detail/ProductPrice1';
import CustomSlider2 from '../CustomSlider2';
import ProductViewDialog from './ProductViewDialog';
import ProductSectionTitle from './ProductSectionTitle';

const TheHomepageIndex = ({ ...rest }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { type, keyword } = useParams();
  const [selectedProductIds, setSelectedProductIds] = useState([]);

  const currentPage = queryParams.get("page");
  const [homepageProductLimit, setLimit] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage, setPage] = useState(currentPage ? parseInt(currentPage) - 1 : 0);
  const { homepageProductItems, homepageProductTotal, homepageProductFilter } = useSelector(state => state.product);

  const currentPage_1 = queryParams.get("page_1");
  const [homepageProductLimit_1, setLimit_1] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage_1, setPage_1] = useState(currentPage_1 ? parseInt(currentPage_1) - 1 : 0);
  const { homepageProductItems_1, homepageProductTotal_1, homepageProductFilter_1 } = useSelector(state => state.product);

  const currentPage_2 = queryParams.get("page_2");
  const [homepageProductLimit_2, setLimit_2] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage_2, setPage_2] = useState(currentPage_2 ? parseInt(currentPage_2) - 1 : 0);
  const { homepageProductItems_2, homepageProductTotal_2, homepageProductFilter_2 } = useSelector(state => state.product);

  const currentPage_3 = queryParams.get("page_3");
  const [homepageProductLimit_3, setLimit_3] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage_3, setPage_3] = useState(currentPage_3 ? parseInt(currentPage_3) - 1 : 0);
  const { homepageProductItems_3, homepageProductTotal_3, homepageProductFilter_3 } = useSelector(state => state.product);

  const currentPage_4 = queryParams.get("page_4");
  const [homepageProductLimit_4, setLimit_4] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage_4, setPage_4] = useState(currentPage_4 ? parseInt(currentPage_4) - 1 : 0);
  const { homepageProductItems_4, homepageProductTotal_4, homepageProductFilter_4 } = useSelector(state => state.product);

  const currentPage_5 = queryParams.get("page_5");
  const [homepageProductLimit_5, setLimit_5] = useState(DEFAULT_HOMEPAGE_ROW_PER_PAGE_PRODUCT);
  const [homepageProductPage_5, setPage_5] = useState(currentPage_5 ? parseInt(currentPage_5) - 1 : 0);
  const { homepageProductItems_5, homepageProductTotal_5, homepageProductFilter_5 } = useSelector(state => state.product);
  
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)
  const { isLoading } = useSelector(state => state.app);
  const [selectedIndexes, setSelectedIndexes] = useState({});
  const [currentProductId, setCurrentProductId] = useState("");
  const [currentPriceIndex, setCurrentPriceIndex] = useState("");
  const [currentProduct, setCurrentProduct] = useState("");
  
  useEffect(() => {
    setPage(currentPage ? parseInt(currentPage - 1): 0);
  }, [currentPage])

  useEffect(() => {
    setPage_1(currentPage_1 ? parseInt(currentPage_1 - 1): 0);
  }, [currentPage_1])

  useEffect(() => {
    setPage_2(currentPage_2 ? parseInt(currentPage_2 - 1): 0);
  }, [currentPage_2])

  useEffect(() => {
    setPage_3(currentPage_3 ? parseInt(currentPage_3 - 1): 0);
  }, [currentPage_3])

  useEffect(() => {
    setPage_4(currentPage_4 ? parseInt(currentPage_4 - 1): 0);
  }, [currentPage_4])

  useEffect(() => {
    setPage_5(currentPage_5 ? parseInt(currentPage_5 - 1): 0);
  }, [currentPage_5])
  
  useEffect(() => {
    const payload = {
      ...homepageProductFilter,
      homepageProductLimit: homepageProductLimit,
      homepageProductPage: homepageProductPage,
      product_type: 'xe_may_dien',
    };
    dispatch(ProductAction.updateHomepageFilter(payload));
    dispatch(ProductAction.homepageList())
  }, [homepageProductPage, homepageProductLimit])

  useEffect(() => {
    const payload = {
      ...homepageProductFilter_1,
      homepageProductLimit: homepageProductLimit_1,
      homepageProductPage: homepageProductPage_1,
      product_type: 'xe_dap_dien',
    };
    dispatch(ProductAction.updateHomepageFilter(payload, '_1'));
    dispatch(ProductAction.homepageList('_1'))
  }, [homepageProductPage_1, homepageProductLimit_1])

  useEffect(() => {
    const payload = {
      ...homepageProductFilter_2,
      homepageProductLimit: homepageProductLimit_2,
      homepageProductPage: homepageProductPage_2,
      product_type: 'ac_quy',
    };
    dispatch(ProductAction.updateHomepageFilter(payload, '_2'));
    dispatch(ProductAction.homepageList('_2'))
  }, [homepageProductPage_2, homepageProductLimit_2])

  useEffect(() => {
    const payload = {
      ...homepageProductFilter_3,
      homepageProductLimit: homepageProductLimit_3,
      homepageProductPage: homepageProductPage_3,
      product_type: 'pin',
    };
    dispatch(ProductAction.updateHomepageFilter(payload, '_3'));
    dispatch(ProductAction.homepageList('_3'))
  }, [homepageProductPage_3, homepageProductLimit_3])

  useEffect(() => {
    const payload = {
      ...homepageProductFilter_4,
      homepageProductLimit: homepageProductLimit_4,
      homepageProductPage: homepageProductPage_4,
      product_type: 'phu_tung',
    };
    dispatch(ProductAction.updateHomepageFilter(payload, '_4'));
    dispatch(ProductAction.homepageList('_4'))
  }, [homepageProductPage_4, homepageProductLimit_4])

  useEffect(() => {
    const payload = {
      ...homepageProductFilter_5,
      homepageProductLimit: homepageProductLimit_5,
      homepageProductPage: homepageProductPage_5,
      product_type: 'khac',
    };
    dispatch(ProductAction.updateHomepageFilter(payload, '_5'));
    dispatch(ProductAction.homepageList('_5'))
  }, [homepageProductPage_5, homepageProductLimit_5])

  const handleSelectAll = (event) => {
    let newSelectedProductIds;

    if (event.target.checked) {
      newSelectedProductIds = homepageProductItems.map((product) => product.slug);
    } else {
      newSelectedProductIds = [];
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedProductIds.indexOf(id);
    let newSelectedProductIds = [];

    if (selectedIndex === -1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds, id);
    } else if (selectedIndex === 0) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(1));
    } else if (selectedIndex === selectedProductIds.length - 1) {
      newSelectedProductIds = newSelectedProductIds.concat(selectedProductIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedProductIds = newSelectedProductIds.concat(
        selectedProductIds.slice(0, selectedIndex),
        selectedProductIds.slice(selectedIndex + 1)
      );
    }

    setSelectedProductIds(newSelectedProductIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage, index = null) => {
    if (index) {
      if (index == '1') setPage_1(newPage);
      else if (index == '2') setPage_2(newPage);
      else if (index == '3') setPage_3(newPage);
      else if (index == '4') setPage_4(newPage);
      else if (index == '5') setPage_5(newPage);
    } else {
      setPage(newPage);
    }

    // Gán giá trị mặc định
    queryParams.set("page" + (index !== null ? '_' + index : ""), newPage + 1);

    // Cập nhật URL mà không reload trang
    navigate({
      pathname: location.pathname,
      search: `?${queryParams.toString()}`
    }, { replace: true }); // replace để không thêm vào lịch sử trình duyệt
  };

  const handleConfirmOpen = (type, product) => {
    setSelected(product);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(ProductAction.del(selected.slug))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(ProductAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const totalPages = Math.ceil(homepageProductTotal / homepageProductLimit);
  
  const renderPagination = () => {
      const pages = [];
      const maxPagesToShow = 5;
      
      if (totalPages <= maxPagesToShow) {
          for (let i = 0; i < totalPages; i++) {
              pages.push(i);
          }
      } else {
          if (homepageProductPage > 2) pages.push(0, "...");
          for (let i = Math.max(0, homepageProductPage - 2); i <= Math.min(totalPages - 1, homepageProductPage + 2); i++) {
              pages.push(i);
          }
          if (homepageProductPage < totalPages - 3) pages.push("...", totalPages - 1);
      }
      
      return pages.map((page, index) => (
          <button className={`page-btn ${typeof page === "number" ? (currentPage && parseInt(currentPage) == page + 1 || !currentPage && page == 0 ? "current-selected" : "") : "not-number"}`} key={index} onClick={(e) => typeof page === "number" && handlePageChange(e, page)}
              disabled={page === homepageProductPage || page === "..."} style={{
                  
              }}>
              {page === "..." ? "..." : page + 1}
          </button>
      ));
  };

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // hoặc 'auto'
    });
  };

  const categoryName = type => {
    if (type === 'xe-may-dien') {
        return "Xe máy điện"
    } else if (type === 'xe-dap-dien') {
        return "Xe đạp điện"
    } else if (type === 'ac-quy') {
        return "Ắc quy"
    } else if (type === 'pin') {
        return "Pin"
    } else if (type === 'phu-tung') {
        return "Phụ tùng"
    } else {
        return "Tất cả sản phẩm"
    }
  };

  const handlePriceChange = (productId, priceIndex) => {
    console.log(productId, ' || ', priceIndex);

    setSelectedIndexes({
      ...selectedIndexes,
      [productId]: priceIndex,
    })
  }

  const viewProduct = (product, productId, priceIndex) => {
    console.log(product, ' || ', productId, ' || ', priceIndex);

    setCurrentProduct(product);
    setCurrentProductId(productId);
    setCurrentPriceIndex(priceIndex);
    setOpen(true);
  };

  const titles = [
    "Xe máy điện",
    "Xe đạp điện",
    "Ắc quy",
    "Pin",
    "Phụ tùng",
    "Sản phẩm khác",
  ];

  return (
    <>
        <Helmet>
            <title>Trang chủ | Xe điện SH - Xe điện Song Đan</title>
        </Helmet>

        {[0,1,2,3,4,5].map((index) => {
          // lấy data đúng theo index
          const items = index === 0 ? homepageProductItems : eval(`homepageProductItems_${index}`);
          const total = index === 0 ? homepageProductTotal : eval(`homepageProductTotal_${index}`);
          const limit = index === 0 ? homepageProductLimit : eval(`homepageProductLimit_${index}`);
          const page  = index === 0 ? homepageProductPage  : eval(`homepageProductPage_${index}`);

          // console.log(index, homepageProductItems_1, homepageProductItems_2);

          return (
            <div key={index}>
              <h2 className="discover-title">
                <ProductSectionTitle title={titles[index]} />
              </h2>

              <div
                className="regular-list-show"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "20px",
                }}
              >
                {items && items.map((product, idx) =>
                  product ? (
                    <div key={idx} className="regular-item">
                      {product.trang_thai == "het_hang" && <div class="pause-stamp">HẾT HÀNG</div>}
                      {product.images && product.images.length > 0 && (() => {
                          let _images = [];

                          if (product.images && product.images.length > 0) {
                              _images = [...product.images].sort((a, b) => a.index - b.index);
                          }
                          return (
                            <div className='image-container'>
                              <CustomSlider2 className="product-detail-banner" banners={_images} showSlideCount={1} showPrevBtn={0} showNextBtn={0} onItemClick={() => navigate(`/trang-chu/san-pham/${product.product_type.replace(/_/g, "-")}/${product.slug}`)} />
                            </div>
                          );
                      })()}
                      <div style={{ opacity: product.trang_thai == "het_hang" ? "0.8" : "1.0", width: "100%" }}>
                          <div className="name" onClick={() => navigate(`/trang-chu/san-pham/${product.product_type.replace(/_/g, "-")}/${product.slug}`)}>{product.name}</div>
                          
                          {/* <div className="price">
                              <ProductPrice1 product={product} onSelectChange={(priceIndex) => handlePriceChange(product.id, priceIndex)} />
                          </div> */}

                          {product.prices?.length > 0 && (
                            <div className="price">
                              <div className="price-title">Giá đề xuất: </div>
                              {(() => {
                                // tìm phần tử có giá thực tế thấp nhất
                                const priceItem = [...product.prices]
                                  .filter(p => p.name?.trim()) // lọc item có name
                                  .sort((a, b) => {
                                    const getActualPrice = (p) =>
                                      p.price_new > 0 && p.price > p.price_new ? p.price_new : p.price;
                                    return getActualPrice(a) - getActualPrice(b);
                                  })[0]; // lấy item đầu tiên (giá thấp nhất)

                                if (!priceItem) return null;

                                const priceNew = Number(priceItem.price_new);
                                const priceOld = Number(priceItem.price);

                                return priceNew > 0 && priceNew < priceOld ? (
                                  <div>
                                    <span className="price-new">{numeral(priceNew).format('0,0')}₫</span>
                                    <span className="price-old">{numeral(priceOld).format('0,0')}₫</span>
                                  </div>
                                ) : (
                                  <div>
                                    <span>{numeral(priceOld).format('0,0')}₫</span>
                                  </div>
                                );
                              })()}
                            </div>
                          )}

                          {1 < 0 && <div className='view-btn-region'>
                            <Button onClick={() => navigate(`/trang-chu/san-pham/${product.product_type.replace(/_/g, "-")}/${product.slug}`)} class="btn-view btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                                <p>
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                      stroke="currentColor" width="18" height="18">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
                                            -1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                  </svg>
                                </p>
                            </Button>

                            <Link to={`/trang-chu/san-pham/${product.product_type.replace(/_/g, "-")}/${product.slug}`} class="btn-buy-now bestSale-btn add-to-cart-v3s btn-sale">
                                <p>
                                    MUA NGAY
                                    <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.25 1.08008L6 5.54075L1.25 10.0014" stroke="white"></path>
                                    </svg>
                                </p>
                            </Link>
                          </div>}
                      </div>
                    </div>
                  ) : null
                )}
              </div>

              <div
                className="list-pagination"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "20px",
                  gap: "5px",
                }}
              >
                <button
                  className='btn-tai-them'
                  onClick={(e) => handlePageChange(e, page + 1, index)}
                  disabled={page + 1 >= total / limit}
                >
                  {isLoading ? <div className="loading" style={{width: 20, height: 20}}></div> : `TẢI THÊM (${numeral(items?.length || 0).format("0,0")} / ${numeral(total || 0).format("0,0")})`}
                </button>
              </div>
            </div>
          );
        })}

        <ProductViewDialog open={open} handleClose={handleClose} type={"EDIT"} product={currentProduct} productId={currentProductId} priceIndex={currentPriceIndex} />
    </>
  );
};

export default TheHomepageIndex;
